import { DesignData } from 'src/store/design/types';
import calculateCorrectProductUid from './calculateCorrectProductUid';

/**
 * Ensures the design structure has the correct product_uid based on populated spreads
 * For products with variants, this will update the product_uid to match the variant
 * that corresponds to the spreads with content
 *
 * @param structure - The design structure
 * @returns The design structure with the correct product_uid, or the original if no change needed
 */
const ensureCorrectProductUid = (structure: DesignData): DesignData => {
  const correctProductUid = calculateCorrectProductUid(structure);

  if (correctProductUid && correctProductUid !== structure.product_uid) {
    return { ...structure, product_uid: correctProductUid };
  }

  return structure;
};

export default ensureCorrectProductUid;
